import React, { useEffect, useState } from "react";
import "../../PermissionsPage.css";
import {GET_PERMISSIONS_FOR_USER, UPDATE_PERMISSION_FOR_USER } from "../../api/ApiConst";
import ApiCaller from "../../api/ApiCaller";

const PermissionsPage = () => {
    const [permissions, setPermissions] = useState([]);
    const url = new URL(window.location.href);
    const userId = url.pathname.split('/')[2];

    // Fetch permissions data on mount
    const getModuleWisePermission = () => {
        const getClient = GET_PERMISSIONS_FOR_USER.replaceAll('{userId}',userId);

        ApiCaller.callGetApi(
            getClient, 
            {}, 
            (response) => {
                setPermissions(response.responsePacket);
            },
            (error) => {
                console.error("Error fetching permissions:", error);
            }
        );
    };

    useEffect(() => {
        getModuleWisePermission();
    }, []);

    // Handle checkbox change for isPermitted
    const handleCheckboxChange = (categoryIndex, permissionIndex) => {
        const updatedPermissions = [...permissions];
        updatedPermissions[categoryIndex].permissions[permissionIndex].permitted = 
            !updatedPermissions[categoryIndex].permissions[permissionIndex].permitted;
        setPermissions(updatedPermissions);
    };

    // Handle module-level checkbox change (Select All for a module)
    const handleModuleCheckboxChange = (categoryIndex) => {
        const updatedPermissions = [...permissions];
        const isAllSelected = updatedPermissions[categoryIndex].permissions.every(
            (permission) => permission.permitted
        );
        // Set all permissions in the module to either true or false
        updatedPermissions[categoryIndex].permissions.forEach((permission) => {
            permission.permitted = !isAllSelected;
        });
        setPermissions(updatedPermissions);
    };

    // Handle update API call
    const updatePermissions = () => {
        const selectedPermissions = permissions
            .flatMap((category) => category.permissions)
            .filter((permission) => permission.permitted)
            .map((permission) => permission.permissionId);  // Assuming each permission has an `id` field

        const updateClient = UPDATE_PERMISSION_FOR_USER.replaceAll('{userId}',userId);
        const data = selectedPermissions;

        ApiCaller.callPostApi(
            updateClient,
            data,
            (response) => {
                alert("Permissions updated successfully!");
            },
            (error) => {
                console.error("Error updating permissions:", error);
            }
        );
    };

    return (
        <div className="permissions-page container">
            <h2>Permissions Management</h2>
            <div className="permissions-container">
                {permissions.map((category, categoryIndex) => (
                    <div key={categoryIndex} className="permissions-category card mb-4">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h5>{category.label}</h5>
                            <input
                                type="checkbox"
                                checked={category.permissions.every((permission) => permission.permitted)}
                                onChange={() => handleModuleCheckboxChange(categoryIndex)}
                                title="Select All"
                            />
                        </div>
                        <div className="card-body">
                            {category.permissions.map((permission, permissionIndex) => (
                                <div key={permissionIndex} className="permission-row row">
                                    <div className="col-6">
                                        <span>{permission.label}</span>
                                    </div>
                                    <div className="col-2 text-center">
                                        <input
                                            type="checkbox"
                                            checked={permission.permitted}
                                            onChange={() =>
                                                handleCheckboxChange(categoryIndex, permissionIndex)
                                            }
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            <button onClick={updatePermissions} className="btn btn-primary mt-4">
                Update Permissions
            </button>
        </div>
    );
};

export default PermissionsPage;
